export enum SolarProductStatus {
    ACTIVE = "Active",
    PAUSED = "Paused",
    ARCHIVED = "Archived",
    NEW = "New",
}